"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_GENERIC_PERMISSIONS = exports.GenericPermissions = void 0;
/**
 * Permission string catalog for Generic and Brand Master (Stage 14,
 * Phase 1 — Pharmacy Master Data Foundation). Houses Brand too, since
 * the brief names no separate Brand catalog (ADR-030 decision 13).
 */
exports.GenericPermissions = {
    GENERIC_MASTER_READ: 'generic-master:read',
    GENERIC_MASTER_CREATE: 'generic-master:create',
    GENERIC_MASTER_UPDATE: 'generic-master:update',
    GENERIC_MASTER_DELETE: 'generic-master:delete',
    GENERIC_MASTER_MANAGE: 'generic-master:manage',
    GENERIC_MASTER_APPROVE: 'generic-master:approve',
    BRAND_MASTER_READ: 'brand-master:read',
    BRAND_MASTER_CREATE: 'brand-master:create',
    BRAND_MASTER_UPDATE: 'brand-master:update',
    BRAND_MASTER_DELETE: 'brand-master:delete',
    BRAND_MASTER_MANAGE: 'brand-master:manage',
    BRAND_MASTER_APPROVE: 'brand-master:approve',
};
exports.ALL_GENERIC_PERMISSIONS = Object.values(exports.GenericPermissions);
//# sourceMappingURL=generic.permissions.js.map